// Module
var code = "<div class=\"contact-identification-scenario\"> <table-list table-title=\"{{vm.identificationTitle}}\" column-header=\"vm.columnHeader\" column-content=\"vm.columnContent\" grid-template=\"vm.gridTemplate\" edit-handler=\"vm.editHandler\" delete-handler=\"vm.deleteHandler\"/> </div> ";
// Exports
module.exports = code;